module.exports = __webpack_public_path__ + "img/suzhou.png";